import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { FAQPageSchema } from '@/components/feature/SEOSchema';

const faqData = [
  {
    question: '17吃瓜网是什么？',
    answer: '17吃瓜网是一个专注娱乐八卦、明星动态、热门瓜料的资讯聚合平台。我们每日更新最新吃瓜内容，涵盖影视圈、音乐圈、网红圈等全领域热点事件，让您第一时间掌握娱乐圈最新动态。',
  },
  {
    question: '17吃瓜网的资讯来源可靠吗？',
    answer: '我们的资讯来源于多渠道收集和整理，包括公开媒体报道、社交媒体信息以及行业内部人士的爆料。我们会尽力核实信息的真实性，但娱乐资讯具有一定的不确定性，建议读者理性看待。',
  },
  {
    question: '如何向17吃瓜网投稿爆料？',
    answer: '您可以通过邮箱 tips@17chigua.com 向我们投稿爆料。我们会对每一条爆料进行认真审核，一经采用，将根据爆料的独家性和价值给予相应的稿酬。您的个人信息将严格保密。',
  },
  {
    question: '17吃瓜网的内容多久更新一次？',
    answer: '17吃瓜网每日更新，我们的编辑团队全天候关注娱乐圈动态，确保您能在第一时间获取最新的娱乐八卦资讯。重要热点事件我们会在最快时间内发布报道。',
  },
  {
    question: '如何联系17吃瓜网？',
    answer: '您可以通过以下方式联系我们：商务合作请发送邮件至 biz@17chigua.com，内容合作和投稿请发送至 tips@17chigua.com，用户反馈请发送至 contact@17chigua.com。您也可以关注我们的微博和微信公众号获取最新动态。',
  },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 17吃瓜网';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', '了解17吃瓜网品牌故事、团队介绍、平台口碑及联系方式。17吃瓜网是专注娱乐八卦资讯聚合平台，致力于为用户提供最新最全的吃瓜内容。');
    }
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <FAQPageSchema questions={faqData} />
      <Navbar />
      <div className="pt-16">
        <Breadcrumb />

        <section className="py-8 md:py-10">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">关于17吃瓜网</h1>
              <p className="text-sm text-foreground-600 text-center mt-3 leading-relaxed">
                专注娱乐八卦，做最懂你的吃瓜平台
              </p>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-10 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1 h-5 rounded-full bg-primary-500"></div>
                <h2 className="font-heading text-xl font-bold text-foreground-900">品牌介绍</h2>
              </div>

              <div className="prose prose-lg max-w-none text-foreground-700 leading-relaxed space-y-4">
                <p>
                  <strong>17吃瓜网</strong>成立于2020年，是国内领先的<strong>娱乐八卦资讯聚合平台</strong>。我们致力于为关注娱乐圈动态的用户提供最新、最全、最劲爆的<strong>吃瓜内容</strong>。
                </p>
                <p>
                  在信息爆炸的时代，娱乐资讯鱼龙混杂，真假难辨。17吃瓜网以专业的态度和敏锐的嗅觉，从海量信息中筛选出真正有价值的<strong>明星八卦</strong>和<strong>娱乐热点</strong>，帮助用户在最短时间内掌握最有料的资讯。
                </p>
                <p>
                  我们的内容覆盖<strong>影视圈</strong>、<strong>音乐圈</strong>、<strong>网红圈</strong>、<strong>综艺</strong>、<strong>时尚</strong>、<strong>体育</strong>、<strong>国际娱乐</strong>等多个领域，无论是顶流明星的私生活、热门综艺的幕后故事，还是网红达人的真实面貌，你都能在17吃瓜网找到。
                </p>
                <p>
                  "吃瓜"是一种生活态度，代表着对世界的好奇和对真相的追求。17吃瓜网希望成为每一位"吃瓜群众"最信赖的信息来源，让吃瓜变得更简单、更高效、更有趣。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-10 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1 h-5 rounded-full bg-accent-500"></div>
                <h2 className="font-heading text-xl font-bold text-foreground-900">平台口碑</h2>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                <div className="p-6 rounded-xl bg-background-100 text-center">
                  <div className="text-3xl font-bold text-primary-500 font-heading">500万+</div>
                  <p className="text-sm text-foreground-600 mt-2">月活跃用户</p>
                </div>
                <div className="p-6 rounded-xl bg-background-100 text-center">
                  <div className="text-3xl font-bold text-accent-500 font-heading">2000万+</div>
                  <p className="text-sm text-foreground-600 mt-2">月浏览量</p>
                </div>
                <div className="p-6 rounded-xl bg-background-100 text-center">
                  <div className="text-3xl font-bold text-primary-500 font-heading">10万+</div>
                  <p className="text-sm text-foreground-600 mt-2">累计文章数</p>
                </div>
              </div>

              <div className="mt-8 space-y-4">
                <div className="p-5 rounded-xl bg-background-100 border-l-4 border-primary-500">
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    "17吃瓜网是我每天的必刷网站，更新速度快，内容质量高，基本想看的八卦这里都有。"
                  </p>
                  <p className="text-xs text-foreground-500 mt-2">—— 资深吃瓜用户 小王</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border-l-4 border-accent-500">
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    "作为娱乐自媒体人，17吃瓜网是我重要的信息源之一，分类清晰，查找方便，强烈推荐！"
                  </p>
                  <p className="text-xs text-foreground-500 mt-2">—— 娱乐博主 @娱乐圈观察者</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border-l-4 border-secondary-500">
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    "相比其他八卦网站，17吃瓜网的内容更加客观中立，不会刻意带节奏，这点很难得。"
                  </p>
                  <p className="text-xs text-foreground-500 mt-2">—— 媒体从业者 李先生</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-10 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1 h-5 rounded-full bg-secondary-500"></div>
                <h2 className="font-heading text-xl font-bold text-foreground-900">联系我们</h2>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                <div className="p-6 rounded-xl bg-background-50 text-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-3">
                    <i className="ri-mail-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 text-sm mb-1">商务合作</h3>
                  <a href="mailto:biz@17chigua.com" className="text-xs text-primary-500 hover:text-primary-600 transition-colors">
                    biz@17chigua.com
                  </a>
                </div>
                <div className="p-6 rounded-xl bg-background-50 text-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mx-auto mb-3">
                    <i className="ri-send-plane-line text-xl text-accent-500"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 text-sm mb-1">内容投稿</h3>
                  <a href="mailto:tips@17chigua.com" className="text-xs text-accent-500 hover:text-accent-600 transition-colors">
                    tips@17chigua.com
                  </a>
                </div>
                <div className="p-6 rounded-xl bg-background-50 text-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 mx-auto mb-3">
                    <i className="ri-customer-service-2-line text-xl text-secondary-500"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 text-sm mb-1">用户反馈</h3>
                  <a href="mailto:contact@17chigua.com" className="text-xs text-secondary-500 hover:text-secondary-600 transition-colors">
                    contact@17chigua.com
                  </a>
                </div>
              </div>

              <div className="mt-8 p-6 rounded-xl bg-background-50">
                <h3 className="font-heading font-semibold text-foreground-900 mb-4">社交媒体</h3>
                <div className="flex flex-wrap gap-3">
                  <a href="#weibo" target="_blank" rel="nofollow noopener" className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100 text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer">
                    <i className="ri-weibo-line text-lg"></i> 新浪微博
                  </a>
                  <a href="#wechat" target="_blank" rel="nofollow noopener" className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100 text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer">
                    <i className="ri-wechat-line text-lg"></i> 微信公众号
                  </a>
                  <a href="#douyin" target="_blank" rel="nofollow noopener" className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100 text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer">
                    <i className="ri-tiktok-line text-lg"></i> 抖音
                  </a>
                  <a href="#xiaohongshu" target="_blank" rel="nofollow noopener" className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100 text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer">
                    <i className="ri-bookmark-line text-lg"></i> 小红书
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1 h-5 rounded-full bg-primary-500"></div>
                <h2 className="font-heading text-xl font-bold text-foreground-900">
                  <a href="#faq" id="faq" className="text-foreground-900 no-underline">常见问题</a>
                </h2>
              </div>

              <div className="space-y-3">
                {faqData.map((faq, idx) => (
                  <details key={idx} className="group rounded-xl bg-background-100 overflow-hidden">
                    <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                      <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                      <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}